/**
 * Gets the current URL search parameters
 * @returns URLSearchParams object
 */
export var getSearchParams = function () {
    return new URLSearchParams(window.location.search);
};
/**
 * Updates the URL search parameters by removing a specific parameter
 * @param paramName - The name of the parameter to remove
 * @returns void
 */
export var removeSearchParam = function (paramName) {
    var params = getSearchParams();
    params.delete(paramName);
    var newSearch = params.toString();
    var newUrl = "".concat(window.location.pathname).concat(newSearch ? "?".concat(newSearch) : '').concat(window.location.hash);
    window.history.replaceState(null, '', newUrl);
};
/**
 * Checks if a specific parameter exists in the URL search parameters
 * @param paramName - The name of the parameter to check
 * @param value - Optional value to check against
 * @returns boolean indicating if the parameter exists (and matches the value if provided)
 */
export var hasSearchParam = function (paramName, value) {
    var params = getSearchParams();
    if (value) {
        return params.get(paramName) === value;
    }
    return params.has(paramName);
};
/**
 * Gets the value of a specific parameter from the URL search parameters
 * @param paramName - The name of the parameter to get
 * @returns The value of the parameter, or null if it doesn't exist
 */
export var getSearchParamValue = function (paramName) {
    var params = getSearchParams();
    return params.get(paramName);
};
